import { isAdmin, isAnyAdmin, isCustomRole, isEmployee } from 'permissions/v1/roles';
import { canCreate, canDestroy, canList, canUpdate, canView } from 'permissions/v1/index';

const permission = 'Facility';

const list = (profile) =>
  isAnyAdmin(profile) ||
  isEmployee(profile) ||
  isCustomRole(profile) ||
  canList(permission, profile);
const view = (profile) => isAnyAdmin(profile) || canView(permission, profile);
const create = (profile) => isAdmin(profile) || canCreate(permission, profile);
const update = (profile) => isAdmin(profile) || canUpdate(permission, profile);
const destroy = (profile) => isAdmin(profile) || canDestroy(permission, profile);

const permissions = (profile) => {
  return {
    list: list(profile),
    view: view(profile),
    create: create(profile),
    update: update(profile),
    destroy: destroy(profile),
  };
};

export default permissions;
